import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import Gray_Btn from "../../../../../../common/common_btn/gray_btn/Gray_Btn";
import Black_Submit_Btn from "../../../../../../common/common_btn/black_submit_btn/Black_Submit_Btn";
import { Controller, useForm } from "react-hook-form";
import Select from "react-select";
import "./Sample_Report_Filter.css";
import Success_Toster from "../../../../../../common/common_modal/success_toster/Success_Toster";
import { FixIDS } from "../../../../../../utils/fixIDS";
import { useDispatch, useSelector } from "react-redux";
import { AllCustomer } from "../../../../../../features/admin/common/Slice";

const Sample_Report_Filter = ({
  setShow,
  setSearchName,
  reportgenerate,
  reportgenerateYearly,
}) => {
  const [success, setSuccess] = useState(false);

  // 🔹 filter states
  const [methodOfTesting, setMethodOfTesting] = useState("");
  const [sampleUniqueId, setSampleUniqueId] = useState("");
  const [tat, setTat] = useState("");
  const [sampleStatusId, setSampleStatusId] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [customer, setCustomer] = useState("");
  const [selectedYear, setSelectedYear] = useState("");

  const permissions = useSelector((state) => state.auth.permissions);
  const haveDownloadPermission = permissions?.includes(FixIDS.sample_report.Report_Download);
  const haveReportPermission = permissions?.includes(FixIDS.sample_report.Report);

  // ⏱ auto hide toaster after 3 sec
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => setSuccess(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [success]);
  const dispatch = useDispatch();
  const all_customer = useSelector((state) => state.common.all_customer);
  useEffect(() => {
    dispatch(AllCustomer());
  }, [dispatch]);

  const startYear = 2026;
  const currentYear = new Date().getFullYear();

  const years = [];
  for (let i = startYear; i <= currentYear; i++) {
    years.push(i);
  }

  
    

  return (
    <section className="Sample_Report_Filter">
      <div className="row me-0 ms-0">
        <div className="col-lg-10">
          <div className="common_filter_div">
            <div className="row">
              <div className="col-xxl-10 col-xl-9 col-lg-12 col-md-12">
                <Form className="form_div">
                  <div className="row g-1">
                    {/* SEARCH BY */}
                    <div className="col-xl-4 col-lg-12 col-md-12 col-sm-12 col-12">
                      <div className="filter_div border_div">
                        <Form.Group>
                           <Form.Label>Search By :</Form.Label>
                          <div className="row g-1">
                            <div className="col-xxl-6 col-xl-12 col-xxl-4 col-xl-6 col-md-6 col-sm-6 col-6 mb-2">
                              <Select
                                isSearchable
                                options={all_customer}
                                value={customer}
                                onChange={(e) => {
                                  setCustomer(e);
                                }}
                                placeholder="Select Customer"
                              />
                            </div>
                            <div className="col-xxl-6 col-xl-12 col-xxl-4 col-xl-6 col-md-6 col-sm-6 col-6 mb-2">
                              <Form.Control
                                type="text"
                                placeholder="Method Of Testing"
                                value={methodOfTesting}
                                onChange={(e) =>
                                  setMethodOfTesting(e.target.value)
                                }
                              />
                            </div>
                            <div className="col-xxl-6 col-xl-12 col-xxl-4 col-xl-6 col-md-6 col-sm-6 col-6 mb-2">
                              <Form.Control
                                type="text"
                                placeholder="Sample ID"
                                value={sampleUniqueId}
                                onChange={(e) =>
                                  setSampleUniqueId(e.target.value)
                                }
                              />
                            </div>
                          </div>
                        </Form.Group>
                      </div>
                    </div>

                    {/* FILTER BY */}
                    <div className="col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                      <div className="filter_div">
                        <Form.Group>
                          <div className="row g-1">
                            <div className="col-xxl-3 col-xl-6 col-xxl-4 col-xl-6 col-md-6 col-sm-6 col-6 mb-2">
                              <Form.Label>Start Date:</Form.Label>
                              <Form.Control
                                type="date"
                                placeholder="Received Date"
                                value={startDate}
                                // onChange={(e) => setStartDate(e.target.value)}
                                onChange={(e) => {
                                  let value = e.target.value;
                                  const parts = value.split("-");

                                  if (parts[0] && parts[0].length > 4) {
                                    parts[0] = parts[0].slice(0, 4);
                                    e.target.value = parts.join("-");
                                  }
                                  setStartDate(e.target.value);
                                }}
                              />
                            </div>

                            <div className="col-xxl-3 col-xl-6 col-xxl-4 col-xl-6 col-md-6 col-sm-6 col-6 mb-2">
                              <Form.Label>End Date:</Form.Label>
                              <Form.Control
                                type="date"
                                placeholder="Report Date"
                                value={endDate}
                                // onChange={(e) => setEndDate(e.target.value)}
                                onChange={(e) => {
                                  let value = e.target.value;
                                  const parts = value.split("-");

                                  if (parts[0] && parts[0].length > 4) {
                                    parts[0] = parts[0].slice(0, 4);
                                    e.target.value = parts.join("-");
                                  }
                                  setEndDate(e.target.value);
                                }}
                              />
                            </div>
                            <div className="col-xxl-3 col-xl-6 col-xxl-4 col-xl-6 col-md-6 col-sm-6 col-6 mb-2">
                              <Form.Label>Year</Form.Label>
                              <Form.Select
                                className="form-control"
                                value={selectedYear}
                                onChange={(e) =>
                                  setSelectedYear(e.target.value)
                                }
                              >
                                <option value="">Select Year</option>

                                {years.map((year) => (
                                  <option key={year} value={year}>
                                    {year}
                                  </option>
                                ))}
                              </Form.Select>
                            </div>

                            {/* STATUS DROPDOWN (ID based) */}
                            <div className="col-xxl-3 col-xl-6 col-xxl-4 col-xl-6 col-md-6 col-sm-6 col-6 mb-2">
                              <Form.Label>Status</Form.Label>
                              <Form.Select
                                className="form-control"
                                value={sampleStatusId}
                                onChange={(e) =>
                                  setSampleStatusId(e.target.value)
                                }
                              >
                                <option value="">Status</option>
                                <option value="1">Scheduled</option>
                                <option value="2">In Progress</option>
                                <option value="3">Verified</option>
                                <option value="4">Pending Review</option>
                              </Form.Select>
                            </div>

                            <div className="col-xxl-3 col-xl-6 col-xxl-4 col-xl-6 col-md-6 col-sm-6 col-6 mb-2">
                              <Form.Label>TAT</Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="TAT"
                                value={tat}
                                onChange={(e) => setTat(e.target.value)}
                                onKeyDown={(e) => {
                                  const value = e.target.value;

                                  // Allow control keys
                                  if (
                                    [
                                      "Backspace",
                                      "Delete",
                                      "Tab",
                                      "ArrowLeft",
                                      "ArrowRight",
                                    ].includes(e.key)
                                  ) {
                                    return;
                                  }

                                  // Allow numbers
                                  if (/^[0-9]$/.test(e.key)) {
                                    return;
                                  }

                                  // Allow ONE decimal point
                                  if (e.key === "." && !value.includes(".")) {
                                    return;
                                  }

                                  // Block everything else
                                  e.preventDefault();
                                }}
                              />
                            </div>
                          </div>
                        </Form.Group>
                      </div>
                    </div>
                  </div>
                </Form>
              </div>

              <div className="col-xxl-2 col-xl-3 col-lg-12 col-md-12">
                <div className="btns_holder">
                  <>
                    <Gray_Btn
                      btnText="Reset"
                      onClick={() => {
                        setMethodOfTesting("");
                        setSampleUniqueId("");
                        setTat("");
                        setStartDate("");
                        setEndDate("");
                        setSampleStatusId("");
                        setCustomer("");
                        setSearchName({
                          method_of_testing: "",
                          sample_unique_id: "",
                          tat: "",
                          sample_management_status_id: "",
                          end_date: "",
                          start_date: "",
                          customer_id: "",
                          year: "",
                        });
                      }}
                    />

                    <Black_Submit_Btn
                      btnText="Search"
                      onClick={() => {
                        setSearchName({
                          method_of_testing: methodOfTesting,
                          unique_id: sampleUniqueId,
                          tat: tat,
                          sample_management_status_id: sampleStatusId,
                          start_date: startDate,
                          end_date: endDate,
                          customer_id: customer?.value,
                          year: selectedYear,
                        });
                        setSuccess(true);
                      }}
                    />
                  </>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-2 p-0">
          { haveDownloadPermission && <div className="add_sample_div mb-3" onClick={() => reportgenerate()}>
            <div className="add_img_div">
              <img src="/assets/images/other/report.png" className="add_img" />
            </div>
            <p className="inner_text">Generate Report</p>
          </div> }

          { haveDownloadPermission && <div
            className="add_sample_div"
            onClick={() => reportgenerateYearly()}
          >
            <div className="add_img_div">
              <img src="/assets/images/other/report.png" className="add_img" />
            </div>
            <p className="inner_text">Generate Report Yearly</p>
          </div> }
        </div>
      </div>
    </section>
  );
};

export default Sample_Report_Filter;
